import Icon from 'components/atoms/Icon';
import { ReactNode } from 'react';
import { useTranslation } from 'react-i18next';
import styles from './SystemBanner.module.scss';

export type SystemBannerColor = 'warning' | 'error';

export interface SystemBannerProps {
  icon: ReactNode;
  color: SystemBannerColor;
  visible: boolean;
  dismissable: boolean;
  content: ReactNode;
  onDismiss?: () => void;
}

const SystemBanner = ({
  icon,
  color,
  visible,
  dismissable,
  content,
  onDismiss,
}: SystemBannerProps) => {
  const { t } = useTranslation();
  const colorClass = color === 'warning' ? styles.warning : styles.error;

  return (
    <div className={styles.systemBannerContainer}>
      <div
        className={`${styles.systemBannerTextContainer} ${colorClass} ${
          visible ? styles.slideIn : styles.slideOut
        }`}
        role="alert"
        aria-live="polite"
      >
        <div className={styles.systemBannerContent}>
          <div className={styles.iconContainer}>{icon}</div>
          <div className={styles.textContent}>{content}</div>
        </div>
        {dismissable && onDismiss && (
          <button
            className={styles.dismissButton}
            onClick={onDismiss}
            type="button"
            aria-label={t('common.dismissNotification')}
          >
            <Icon icon="close" className={styles.dismissButtonIcon} />
          </button>
        )}
      </div>
    </div>
  );
};

export default SystemBanner;
